import {observer} from 'mobx-react-lite'
import CompanyInfo from '../../CompanyInfo'
import {useLocation} from "react-router-dom";
import {useEffect} from "react";
import clubStore from "../../../storage/ClubStore";

const ShowCompany = () => {
  const location = useLocation();
  useEffect(() => {
    if (clubStore.teams.length === 0) {
      clubStore.getTeams()
    }
    clubStore.getTrainersForClub()
  }, [location.pathname])
  const club = clubStore.club
  return (
    <CompanyInfo club={club} trainers={club.trainers} teams={clubStore.teams} />
  );
};

export default observer(ShowCompany)